"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),t=require("./component.js"),r=require("./styles.js");function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=n(e);const o=s.default(t.PlannerCard)``,l=s.default(t.PlannerCard)`
    ${r}
`;exports.Styled=l,exports.Unstyled=o,exports.default=l;
//# sourceMappingURL=index.js.map
